import { fetchPackagePointsProvidersFeatures } from 'api/fetchers/get-package-points-providers-features';
import useSWR from 'swr';
import swrConfig from 'utils/swrConfig';
import { PackageProvidersFeaturesResponse } from '../../../pb/responses/v1/package_providers_features_response_pb';
import { PackageProviderFeature } from '../../../pb/responses/v1/package_provider_features_response_pb';

export const usePPointsFeatures = (providerIds: number[]) => {
    const shouldFetch = providerIds.length > 0;
    const { data, isLoading, error } = useSWR<PackageProvidersFeaturesResponse>(
        shouldFetch ? `package-points-providers-features-${providerIds.join(',')}` : null,
        () => fetchPackagePointsProvidersFeatures(providerIds),
        swrConfig
    );

    const hasFullIntegration = data?.data?.some((feature) => feature.features.includes(PackageProviderFeature.LABEL));

    return { data, isLoading, error, hasFullIntegration };
};
